export const _15MinutesInSeconds = 900;
export const _30MinutesInSeconds = _15MinutesInSeconds * 2;
export const _1HourInSeconds = 3600;
export const _1MinuteInMS = 1000 * 60;
export const _1HourInMS = 3600 * 1000;
export const _1DayInSeconds = _1HourInSeconds * 24;
export const _15MinutesInMS = 900000;
export const _24HoursInMS = 24 * 60 * 60 * 1000;
export const _1SecondInMS = 1000;
